import type { AuditTrailFieldChange } from "@/api/cle-api/models/documents";

import {
  formatAuditTrailFieldLabel,
  formatAuditTrailFieldValue,
} from "./utils/formatAuditTrailFieldChange";

interface AuditTrailFieldChangesProps {
  fieldChanges: AuditTrailFieldChange[];
}

export const AuditTrailFieldChanges = ({
  fieldChanges,
}: AuditTrailFieldChangesProps) => {
  if (fieldChanges.length === 0) {
    return null;
  }

  return (
    <ul className="audit-trail__changes list-unstyled small mb-0 mt-2">
      {fieldChanges.map((change) => (
        <li
          className="audit-trail__change d-flex flex-wrap align-items-baseline gap-2"
          key={change.field}
        >
          <span className="audit-trail__change-label text-muted">
            {formatAuditTrailFieldLabel(change.field)}
          </span>
          <span className="audit-trail__change-values">
            <span className="text-muted text-decoration-line-through">
              {formatAuditTrailFieldValue(change.field, change.original)}
            </span>
            <span aria-hidden className="text-muted mx-1">
              →
            </span>
            <span className="fw-semibold text-body">
              {formatAuditTrailFieldValue(change.field, change.updated)}
            </span>
          </span>
        </li>
      ))}
    </ul>
  );
};
